import type { ElementsTypes } from '@vedalib/editor/lib/elements'

import { BlockMode } from 'services/Store/Project/enums'

import { ElementGroup } from '../elements.types'

export const testMode = [ElementGroup.test]
export const viewMode = [ElementGroup.view, ElementGroup.interactive]
export const coverMode = [ElementGroup.cover, ElementGroup.interactive, ElementGroup.view]

export const testElementTypes: ElementsTypes[] = [
  'testSingleChoice',
  'testMultipleChoice',
  'testRanking',
  'testMatching',
  'testKeyboardInput',
  'testHotspot',
  'testGrouping',
]

export const testConfig: Partial<Record<BlockMode, ElementsTypes[]>> = {
  [BlockMode.start]: ['testInfoStart'],
  [BlockMode.questions]: [...testElementTypes, 'testFeedback'],
  [BlockMode.end]: ['testInfoEnd', 'testResult', 'testGeneralFeedback'],
}
